<template>
  <div class="pagination">
    <button :disabled="currentPage==1" @click="prevPage">上一页</button> 
    {{currentPage}} / {{endPage}} 页 
    <button :disabled="currentPage==endPage" @click="nextPage">下一页</button>
    跳转 <input type="input" class="input" v-model="inputPage" @keydown="changeInput"/> 页
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    total:{
      type: Number,
      default: 1
    },
    resetPage: {
      type: Boolean,
      default: false
    },
    customPageSize: {
      type: Number,
      default: 10
    }
  },
  watch: {
    resetPage (val) {
      console.log(val)
      if (val) {
        this.currentPage = 1
        this.inputPage = 1
        this.jumpPage()
      }
    },
    total (val) {
      this.endPage = Math.ceil(val/this.pageSize)
    }
  },
  data() {
    return {
      currentPage: 1,
      inputPage: '',
      pageSize: 10,
      endPage: 0
    }
  },
  created() {
    this.pageSize = this.customPageSize
    this.jumpPage()
    this.endPage = Math.ceil(this.total/this.pageSize)
  },
  methods: {
    changeInput(e) {
      if (e.keyCode === 13) {
        if (!this.inputPage) {
          this.inputPage = 1
        }
        const inputPage = this.inputPage > this.endPage ? this.endPage : this.inputPage
        this.currentPage = parseInt(inputPage)
        this.inputPage = parseInt(inputPage)
        this.jumpPage()
      }
    },
    prevPage () {
      this.currentPage = this.currentPage - 1
      this.inputPage = ''
      this.jumpPage()
    },
    nextPage () {
      this.currentPage = this.currentPage + 1
      this.inputPage = ''
      this.jumpPage()
    },
    jumpPage() {
      this.$emit('jump', {
        page: this.currentPage - 1,
        page_size: this.pageSize
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.pagination {
  font-size: 14px;
  color: #999999;
  text-align: right;
  button {
    width: 70px;
    height: 24px;
    background: #4E6EFF;
    border-radius: 4px;
    color: #fff;
  }
  .input {
    width: 48px;
    height: 20px;
    border: solid 1px #D8D8D8;
    color: #999999;
    text-align: center;
  }
}
</style>
